"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LocationCreateField = void 0;
var _react = _interopRequireDefault(require("react"));
var _formik = require("formik");
var _alloyReactTheme = _interopRequireDefault(require("@adsk/alloy-react-theme"));
var _accLocationsComponents = require("@adsk/acc-locations-components");
var _FieldWrapper = require("../input-field-components/FieldWrapper");
var _useTranslations = require("../utils/i18n/useTranslations");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const LocationCreateField = _ref => {
  let {
    isRequired = false,
    errorMessage
  } = _ref;
  const {
    T
  } = (0, _useTranslations.useTranslations)();
  const {
    isLoading
  } = (0, _accLocationsComponents.useLocations)();
  const {
    setFieldValue,
    values
  } = (0, _formik.useFormikContext)();
  return /*#__PURE__*/_react.default.createElement(_FieldWrapper.FieldWrapper, {
    label: T.translate("issueAttributes.location"),
    loading: isLoading,
    required: isRequired,
    errorMessage: errorMessage
  }, /*#__PURE__*/_react.default.createElement(_accLocationsComponents.LocationPicker, {
    style: !!errorMessage ? {
      border: "1px solid ".concat(_alloyReactTheme.default.colors.red500),
      borderRadius: 2
    } : undefined,
    selectedNodeId: values.locationId,
    hideIncludeSubLocations: true,
    clearable: true,
    onNodeSelect: location => setFieldValue("locationId", location ? location.id : null),
    "data-testid": "create-issue-modal-locationid"
  }));
};
exports.LocationCreateField = LocationCreateField;
//# sourceMappingURL=LocationCreateField.js.map